<template>
  <div class="w-100 h-100 m-0" style="padding: 32px; background: #FFFFFF;">
    <div class="d-flex flex-column" style="gap: 40px;">
      <div class="m-0 p-0 acry-page-title justify-content-center">発行コード履歴</div>
      <!-- パンクズ -->
      <div class="d-flex" style="gap: 14px; font-size: 13px;">
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnTop()" >
          ACRY TICKET TOP
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnList()" >
          チケット一覧
        </div>
        <div>＞</div>
        <div class="c-pointer" style="text-decoration: underline;" @click="onClickReturnEventEdit()" >
          チケット詳細
        </div>
        <div>＞</div>
        <div>発行コード履歴</div>
      </div>

      <div class="d-flex justify-content-center">
        <div class="position-relative">
          <input
            type="text"
            class="find-input"
            v-model="searchCode"
            placeholder="発行コード"
          />
        </div>
        <button class="bg-transparent border-0" @click="onClickSearch">
          <img
            src="@/assets/acrypro/search.svg"
            class=""
            style="width: 35px; height: 35px"
          />
        </button>
      </div>

      <div class="m-0 acrypro-text-main-bold text-start d-flex justify-content-between" style="height: 56px; border-bottom: solid 1px #8C9BC6; padding: 8px 0px;">
        <div>発行コード</div>
        <button class="m-0 acry-btn fw-bold" style="width: 300px; height: 40px; border-radius: 100px; font-size: 16px;" @click="onClickCSV">
            まとめてコードダウンロード
        </button>
      </div>

      <div class="w-100 m-0 p-0">
        <div class="w-100 d-flex align-items-center text-start table-header" style="font-size: 13px; gap: 24px;">
          <div style="width: 160px;">発行日</div>
          <div style="width: 160px;">有効期限</div>
          <div style="width: 160px;">発行数</div>
          <div style="width: 160px;">発行状況</div>
        </div>
        <div v-for="(data, key) in issueData" :key="key" class="w-100 code-cell d-flex text-start" style="height: 72px; font-size: 15px;" :style="getBgColor(data.validTo)">
          <div class="my-auto" style="width: 184px;">{{formatDate(data.createdAt)}}</div>
          <div class="my-auto d-flex flex-column" style="width: 184px;">
            <div>{{formatDate(data.validFrom)}}〜</div>
            <div>{{formatDate(data.validTo)}}</div>
          </div>
          <div class="my-auto" style="width: 184px;">{{data.requestCount}}</div>
          <div v-if="data.issued" class="my-auto" style="width: 184px;">発行済み</div>
          <div v-if="!data.issued" class="my-auto" style="width: 184px; color: #BC6665;">発行中</div>

          <div class="flex-grow-1"></div>
          <div class="m-auto" style="width: 212px;">
            <button class="m-0 acry-btn fw-bold w-100" style="width: 212px; height: 40px; border-radius: 100px; font-size: 16px;" @click="onClickIssueDetail(data)" :class="{'disable-ui':!data.issued}">
              発行詳細
            </button>
          </div>
        </div>
        <div v-if="issueData.length == 0" style="margin-top: 16px;">
          まだチケットコードは発行されていません
        </div>
      </div>

    </div>

    <!-- 紹介結果モーダル -->
    <div v-if="isShowModal" class="modal-bg" @click="setModal(false)">
      <div class="d-flex flex-column align-items-center position-relative" style="width: 900px; height: 530px; border-radius: 8px; background: #FEFEFE; padding: 40px 0px; gap: 40px;" v-on:click.stop="">
        <div class="fw-bold" style="font-size: 28px;">
          照会結果
        </div>
        <div class="d-flex flex-column text-start" style="gap: 8px; width: 500px;">
          <div class="d-flex flex-column">
            <div class="fw-bold" style="border-bottom: 1px solid #8C9BC6; font-size: 12px; padding: 8px 0px;">
              チケット情報
            </div>
            <div class="d-flex" style="padding: 4px 16px; gap: 24px; border-bottom: 1px solid #D1D5DB; background: #F8F8F8; font-size: 13px;">
              <div style="width: 140px;">コード</div>
              <div>有効期限</div>
            </div>
            <div class="d-flex" style="height: 48px; gap: 24px; padding: 16px; font-size: 12px; border-bottom: 1px solid #D1D5DB;">
              <div style="width: 140px;">{{this.searchCode}}</div>
              <div>{{formatDate(this.resultCode.validFrom)}}〜{{formatDate(this.resultCode.validTo)}}</div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="fw-bold" style="border-bottom: 1px solid #8C9BC6; font-size: 12px; padding: 8px 0px;">
              利用状況
            </div>
            <div class="d-flex" style="padding: 4px 16px; gap: 24px; border-bottom: 1px solid #D1D5DB; background: #F8F8F8; font-size: 13px;">
              <div style="width: 100px;">ステータス</div>
              <div style="width: 100px;">使用日時</div>
              <div style="width: 100px;">受注ID</div>
              <div style="width: 100px;">注文状況</div>
            </div>
            <div class="d-flex align-items-center" style="height: 64px; gap: 24px; padding: 16px; font-size: 12px; border-bottom: 1px solid #D1D5DB;">
              <div v-if="this.resultCode.isUsed" style="width: 100px;">使用済み</div>
              <div v-if="!this.resultCode.isUsed" style="width: 100px;">未使用</div>
              <div v-if="this.resultCode.isUsed" style="width: 100px;">{{formatDate(this.resultCode.usedAt)}}</div>
              <div v-if="!this.resultCode.isUsed" style="width: 100px;">-</div>
              <div v-if="this.resultCode.isUsed" style="width: 100px;">{{this.resultCode.orderId}}</div>
              <div v-if="!this.resultCode.isUsed" style="width: 100px;">-</div>
              <div v-if="this.resultCode.isUsed" style="width: 100px;">{{this.resultCode.orderStatus}}</div>
              <div v-if="!this.resultCode.isUsed" style="width: 100px;">-</div>
            </div>
          </div>
        </div>
        <button class="acry-btn-primary-normal btn-size" @click="setModal(false)">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { CSV } from "@/js/CSV.js";
import { CenterViewState } from "@/js/Const.js";
import { Logger } from '@/js/utils/Logger.js';
import { User } from "@/js/User.js";

export default {
  name: "CenterViewEventTicketIssueHistory_Ap",
  props: {},
  data: function () {
    return {
      issueData:[],
      searchCode:"",
      resultCode: {},
      isShowModal: false,
    };
  },
  computed: {

  },
  async created() {
    this.$store.commit("hideRightMenu");
    this.$store.commit("showLoading");

    this.issueData = await this.$store.state.acrylicTicketCouponManager.getTicketIssueHistory(
      this.$store.state.acrylicTicketCouponManager.selectEditSetting.docId).catch(() => {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "エラーが発生しました");
    });

    this.$store.commit("hideLoading");
  },
  components: {
    
  },
  methods: {
    setModal(isShow){
      this.isShowModal = isShow;
    },

    async onClickSearch(){
      if( !this.searchCode ){
        return;
      }

      const codeData = await this.$store.state.acrylicTicketCouponManager.getTicketData(this.searchCode);
      if( !codeData ){
        alert("存在しないコードです");
        return;
      }

      this.resultCode.isUsed = codeData.isUsed;
      this.resultCode.usedAt = (this.resultCode.isUsed)?codeData.usedAt.toDate():"";
      this.resultCode.validFrom = codeData.validFrom.toDate();
      this.resultCode.validTo = codeData.validTo.toDate();

      if( codeData.isUsed ){
        const orderId = await this.$store.state.acrylicTicketCouponManager.getTicketUsedOrderId(this.searchCode);

        // 使用されている場合は、チケット使用した注文情報も取得
        await User.orderStatus(orderId)
          .then((result) => {
            this.resultCode.orderId = orderId;
            this.resultCode.orderStatus = result.status_name;
          })
          .catch((error) => {
            Logger.error(error);
            this.$store.commit("showMessage", "エラーが発生しました");
          });
      }

     this.setModal(true);

    },
    onClickReturnTop(){
      this.$store.commit("setCenterViewState", CenterViewState.EventManagement);
    },
    onClickReturnList(){
      this.$store.commit("setCenterViewState", CenterViewState.EventList);
    },
    onClickReturnEventEdit(){
      this.$store.commit("setCenterViewState", CenterViewState.EventEdit);
    },
    onClickIssueDetail(data){
      this.$store.state.acrylicTicketCouponManager.selectTicketIssueData = data;
      this.$store.commit("setCenterViewState", CenterViewState.TicketIssueDetail);
    },
    getBgColor(toDate){
      if( toDate > (new Date()) ){
        return {"background": "#FFFFFF"};
      }else{
        return {"background": "#F8F8F8"};
      }
    },
    async onClickAllCSV(){

    },

    async onClickCSV(){
      const csv = new CSV();
      csv.useHeader = true;
      csv.header = ['コード', '開始日', '終了日', '使用日'];
      let csvData = [];

      const codes = await this.$store.state.acrylicTicketCouponManager.getAllAcryCouponCode(this.$store.state.acrylicTicketCouponManager.selectEditSetting.docId);
      for( const code of codes ){
        csvData.push([code.docId, this.formatDate(code.validFrom.toDate()), this.formatDate(code.validTo.toDate()), code.usedAt?this.formatDate(code.usedAt.toDate()):""]);
      }
      csv.data = csvData;
      csv.exportData();
    },

    async onClickReceipt(){

    },

    formatDate(date) {
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.find-input {
  width: 285px;
  height: 48px;
  border: $primary-main-color solid 1px;
  border-radius: 100px;
  background-color: transparent;
  padding: 0px 16px;
}
.table-header{
  width: 800px;
  height: 30px;
  padding: 0px 16px;
  gap: 24px;
  background: #F8F8F8;
  border-bottom: solid 1px #D1D5DB;
}
.code-cell{
  width: 800px;
  height: 120px;
  padding: 16px;
  border-bottom: solid 1px $border-sub-color;
}

.disable-ui{
  cursor: none;
  pointer-events: none;
  opacity: 0.5;
}
</style>


